import React, { useEffect, useRef, useState } from 'react'
import { useFormValidator } from '../../effects/forms/useFormValidator'
import { IBoardView } from './Board'

/**
 * Properties for the edit board component
 */
export interface IEditBoardProps {
    board: IBoardView
    onCancel: () => void
    onSave: (board: IBoardView) => void
}

function EditBoardComponent(props: IEditBoardProps) {
    const nameInput = useRef<HTMLInputElement>(null)

    const [name, setName] = useState(props.board.name)
    const validator = useFormValidator()

    useEffect(() => {
        if (nameInput && nameInput.current) nameInput.current.focus()
    }, [name])

    return (
        <form
            data-testid="editboard-form"
            noValidate
            onSubmit={(event) =>
                validator.handleSubmit(event, () =>
                    props.onSave({ ...props.board, name: name })
                )
            }
            className={`border-0  card ${
                validator.valid ? '' : 'was-validated'
            }`}>
            <div className="card-header rounded-0">
                <div className="form-group">
                    <label htmlFor="edit-board-name">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="edit-board-name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        minLength={2}
                        required
                        ref={nameInput}></input>
                    <div
                        className="invalid-feedback"
                        aria-label="name input error feedback">
                        Please provide a name which is at least 2 character long
                    </div>
                </div>
            </div>
            <div className="card-body">
                <button
                    type="button"
                    className="btn btn-secondary mr-1 btn-outline"
                    aria-label="Cancel Edit Board"
                    onClick={props.onCancel}>
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    aria-label="Save Board">
                    Save
                </button>
            </div>
        </form>
    )
}

export default EditBoardComponent
